export default {
  cta: "cta",
  valuation: "valuation",
  valuationError: "valuationError",
  valuationLoading: "valuationLoading"
};
